<header>
  <div class="pme-container display-utils-row display-utils-between-center">
    <div class="display-utils-row display-utils-between-center">
      <div class="serasa-logo display-utils-row display-utils-start-center">
        <a *ngIf="!isLogged && !isAttendance" href="https://www.serasaempreendedor.com.br/v2/home">
          <img src="/assets/images/logo-serasa.svg" alt="Serasa Experian">
        </a>
        <a *ngIf="isLogged || isAttendance" href="https://www.serasaempreendedor.com.br/v2/home">
          <img src="/assets/images/logo-serasa.svg" alt="Serasa Experian">
        </a>
      </div>
    </div>

    <div class="display-utils-row display-utils-between-center" style="overflow: hidden;">
      <div class="header-title">
        <img class="lock-icon" src="../../../../assets/images/feather-icons/fi_lock.svg">
        <p>Ambiente Seguro</p>
      </div>
    </div>
  </div>
</header>